import location2 from '../assets/images/location2.svg';
import call2 from '../assets/images/call2.svg';
import email from '../assets/images/email.svg';
import { useTranslation } from 'react-i18next';

const Contact = () => {
    const { t } = useTranslation();
    return (
        <div className="">
            <div className='container'>
                <section className='mt-5 pt-5'>
                    <div className='row bg-2 contactus'>
                        <div className='col-md-4'>
                            <div className='d-flex'>
                                <img src={location2} />
                                <span className='ms-3'>
                                    <h6 className='font-color-1 mb-1'>{t('address')}</h6>
                                    <p className='font-color-1 mb-0'>Building, Street name, City, Country</p>
                                </span>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className='d-flex'>
                                <img src={call2} />
                                <span className='ms-3'>
                                    <h6 className='font-color-1 mb-1'>{t('phone')}</h6>
                                    <p className='font-color-1 mb-0'>+91 1234657890</p>
                                </span>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className='d-flex'>
                                <img src={email} />
                                <span className='ms-3'>
                                    <h6 className='font-color-1 mb-1'>{t('email')}</h6>
                                    <p className='font-color-1 mb-0'>example@gmail.com</p>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className='col-md-10 contact-form hide'>
                        <div className='card bg-1 login-card'>
                            <div className='card-body'>
                                <div className='section-title text-center'>
                                    <br />
                                    <h1><span className='font-color-1'>{t('contact1')}</span> <span className='font-color-2'>{t('contact2')}</span></h1>
                                    <br />
                                </div>
                                <div className='row'>
                                    <div className="form-group col-md-6">
                                        <label>{t('name')}</label>
                                        <input type="text" className="form-control" placeholder={t('enter_name')} />
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label>{t('email')}</label>
                                        <input type="email" className="form-control" placeholder={t('enter_email')} />
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label>{t('phone_number')}</label>
                                        <input type="text" className="form-control" placeholder={t('enter_phone')} />
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label>{t('subject')}</label>
                                        <input type="email" className="form-control" placeholder={t('enter_subject')} />
                                    </div>
                                    <div className="form-group col-md-12">
                                        <label>{t('message')}</label>
                                        <textarea className='form-control' placeholder={t('enter_message')} rows={15} cols={5} style={{height:"100px"}}></textarea>
                                    </div>
                                    <div className="form-group text-center mt-3">
                                        <button className="btn btn-primary btn-block col-md-3">{t('send_message')}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

        </div>
    );
}
export default Contact;